import { gql } from '@apollo/client';

export const GET_UPERCUTS = gql`
    query getUpercuts($limit: Int, $offset: Int, $filter: UpercutFilterInput) {
        getUpercuts(limit: $limit, offset: $offset, filter: $filter) {
            upercuts {
                _id
                firstName
                lastName
                email
                role
                color
                assignedRole {
                    _id
                    role {
                        _id
                        name
                        slug
                    }
                    assignedAt
                    isActive
                }
                createdDate
                updatedDate
            }
            total
            hasMore
        }
    }
`;

export const GET_UPERCUT = gql`
    query getUpercut($id: ID!) {
        getUpercut(id: $id) {
            _id
            firstName
            lastName
            email
            role
            color
            assignedRole {
                _id
                role {
                    _id
                    name
                    slug
                }
                assignedAt
                isActive
            }
            createdDate
            updatedDate
        }
    }
`;

export const ADD_UPERCUT = gql`
    mutation addUpercut($upercutInput: UpercutInput!) {
        addUpercut(upercutInput: $upercutInput) {
            _id
            firstName
            lastName
            email
            role
            color
            createdDate
            assignedRole {
                _id
                role {
                    _id
                    name
                    slug
                }
                assignedAt
                isActive
            }
        }
    }
`;

export const UPDATE_UPERCUT = gql`
    mutation updateUpercut($id: ID!, $upercutUpdateInput: UpercutUpdateInput!) {
        updateUpercut(id: $id, upercutUpdateInput: $upercutUpdateInput) {
            _id
            firstName
            lastName
            email
            role
            color
            updatedDate
            assignedRole {
                _id
                role {
                    _id
                    name
                    slug
                }
                assignedAt
                isActive
            }
        }
    }
`;

export const DELETE_UPERCUT = gql`
    mutation deleteUpercut($id: ID!) {
        deleteUpercut(id: $id) {
            _id
            firstName
            lastName
            email
            deletedAt
        }
    }
`;
